import api from '@/core/apiclient'
import { actionTypes, mutationTypes, produto } from '@/core/constants'

export default {
	async [actionTypes.COMUM.BUSCAR_PRODUTO_POR_NOME]({ commit }) {
		const { data } = await api.produto.buscarPorNome(produto.NOME)
		commit(mutationTypes.COMUM.SET_PRODUTO, data)
	},

	async [actionTypes.COMUM.BUSCAR_USUARIO_LOGADO]({ commit, state, dispatch }) {
		const produtoId = state.loki.product.id
		const { data } = await api.usuario.buscarLogado(produtoId)
		commit(mutationTypes.COMUM.SET_USUARIO_LOGADO, data)
		dispatch(actionTypes.COMUM.BUSCAR_PARAMETROS_SISTEMA)
	},

	async [actionTypes.COMUM.BUSCAR_LINK_EDITAR_USUARIO]({ state }) {
		const payload = {
			produto: state.loki.product.name,
			uri: window.location.origin + window.location.pathname,
		}
		const { data } = await api.usuario.editar(payload)
		return data
	},

	async [actionTypes.COMUM.BUSCAR_INFORMACOES_USUARIO]() {
		const { data } = await api.usuario.buscarInformacoes()
		return data
	},

	async [actionTypes.COMUM.ATUALIZAR_SESSAO]({ dispatch }, idOrgao) {
		await api.usuario.atualizarSessao(idOrgao)
		await dispatch(actionTypes.COMUM.BUSCAR_USUARIO_LOGADO)
	},

	async [actionTypes.COMUM.BUSCAR_PARAMETROS_SISTEMA]({ commit }) {
		const { data } = await api.parametrosDoSistema.buscarTodosParametros()
		commit(mutationTypes.COMUM.SET_PARAMETROS_SISTEMA, data)
	},
}
